import { render, staticRenderFns } from "./ui-create-url-tags.vue?vue&type=template&id=53435fa8&"
import script from "./ui-create-url-tags.vue?vue&type=script&lang=ts&"
export * from "./ui-create-url-tags.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports